export default __webpack_public_path__ + "static/media/Vivian.4d5f3744.png";